<template>
  <div class="wrapRank">
    <div class="rankTitle">排行榜 / 评比规则及奖品</div>
    <div class="rankText">活动期间所有任务的完成情况，以及日常行为，都将影响「名厨力」排名</div>
    <div class="about">
      <div class="aboutIcon">
        <div> <span :class="swipeIndex == 0 ? 'styleShow' : ''" /><span :class="swipeIndex == 1 ? 'styleShow' : ''" /></div>
      </div>
      <div class="aboutText">左右滑动查看</div>
      <div class="aboutXian" />
    </div>
    <van-swipe :duration="300" :show-indicators="false" @change="onChange">
      <van-swipe-item>
        <div v-show="swipeIndex == 0" id="hot" class="hot_ranking">
          <div class="hot_top">
            <h3 class="find_title fw500">排行榜 </h3>
            <span>排行榜截止时间：{{ setTime(data.end_time) }}</span>
          </div>
          <div class="ranking_content">
            <div class="list_title">
              <span>排名</span>
              <span style="flex:1">用户名</span>
              <span>名厨力</span>
            </div>
            <ul class="ranking_list">
              <li v-for="(user,i) in data.rank" :key="i" :class="'ranking_item num_'+user.sort">
                <span class="ranking_num style_text fw400">{{ setNum(user.sort) }}</span>
                <div class="name_pic">
                  <div class="name_group">
                    <img class="user_pic" :src="user.head_pic_url" alt="">
                    <span class="user_names text_overflow"> {{ user.nick_name }}</span>
                  </div>
                </div>
                <span class="score_num style_text fw400">{{ user.score }}</span>
              </li>
            </ul>
            <div class="self_show" v-if="data.is_sign==1">
              <div class="self_top">
                <div class="self_title"><h4 class="fw500">我的排名</h4> <span @click="setRuleShow('「名厨力」攻略')">「名厨力」攻略 <i class="svg svg_warning" /></span> </div>
                <template v-if="data.sort == 1">
                  <p>第一名！查看「名厨力」攻略，继续保持领先！</p>
                </template>
                <template v-else>
                  <template v-if="data.variance == 0">
                    <p>距离提升名次一步之遥</p>
                    <p>快点击「名厨力」攻略加速超过他吧！</p>
                  </template>
                  <template v-else>
                    <p>距离上一名「名厨力」仅差 <span class="color_mc fw500">{{ data.variance }}</span></p>
                    <p>快点击「名厨力」攻略加速超过他吧！</p>
                  </template>
                </template>
              </div>
              <div class="ranking_item">
                <span class="ranking_num style_text fw400">{{ data.sort }}</span>
                <div class="name_pic">
                  <div class="name_group">
                    <img class="user_pic" :src="data.head_pic_url" alt="">
                    <span class="user_names text_overflow">{{ data.nick_name }}</span>
                  </div>
                </div>
                <span class="style_text score_num fw400">{{ data.score }}</span>
              </div>
            </div>
          </div>
        </div>
      </van-swipe-item>
      <van-swipe-item>
        <div class="rankPrize">
          <ol class="prizeRule">
            <li v-for="(item,index) in PrizeList" :key="index">{{ item }}</li>
          </ol>
          <Reward/>
        </div>
      </van-swipe-item>
    </van-swipe>

  </div>
  <ActionSheet
    :rule-show="ruleShow"
    :rule-title="ruleTitle"
    @onCancel="ruleCancel"
  />
</template>
<script setup>
import { ref } from 'vue'
import ActionSheet from './ActionSheet'
import { Swipe as vanSwipe, SwipeItem as vanSwipeItem } from 'vant'
import Reward from '../components/Reward'

import { watch, defineProps, reactive } from 'vue'
import utils from '@/utils/utils.js'
const ruleShow = ref(false)
const swipeIndex = ref(0)
const ruleTitle = ref('常见问题')
const PrizeList = reactive(['依据试用挑战作品质量、「名厨力」排名（各占比 50%），综合评选出 1 位用户，获得「杭州米其林指南发布庆典门票」；', ' 依据「名厨力」排名、近半年内完整作品数量及热度值（各占比 50%），综合评选出 6 名用户，获得「探访杭州新晋米其林餐厅」机会；', '「名厨力」排名前 10 的用户即可获得名厨定制周边。']
)
const data = ref({})

const onChange = (index) => {
  swipeIndex.value = index
}
const props = defineProps({
  dataInfo: {
    type: Object,
    default: () => {}
  }
})
const setTime = (time) => {
  return utils.formatTime(time)
}
const setNum = (num) => {
  return num < 10 ? '0' + num : num
}
const setRuleShow = (title) => {
  ruleTitle.value = title
  ruleShow.value = true
}
const ruleCancel = (title) => {
  ruleShow.value = false
}
watch(() => props.dataInfo, (newVal, oldVal) => {
  data.value = newVal
}, { immediate: true })

</script>
<style lang="scss" scoped>
.wrapRank{
  background:#fff;margin-top:10px;
  .about{
    padding:0 18px;margin-top:14px;
    .aboutIcon{
      display: flex;justify-content: center;
      div{width:53px;display:flex;align-items:center;justify-content:space-between;
        span{width: 24px;height: 4px;background: #E5E5E5;border-radius: 23px;display:inline-block;}
        .styleShow{background: #C99700;}
      }
    }
    .aboutText{color: #999999;font-size: 12px;text-align:center;margin:4px 0 12px 0;}
    .aboutXian{padding:0 18px;background:#CCCCCC;height:1px;opacity: 0.2;}
  }
  .rankTitle{color: #333333;font-weight: bold;font-size: 18px; padding:16px 18px 0 18px;text-align:center;}
  .rankText{color: #666666;font-size: 14px;text-align:left;margin-top:4px;padding: 0 18px;}
  .rankPrize{
    padding: 16px 18px 16px 18px;
    .prizeRule{list-style-type: decimal;padding-left:18px;padding-bottom:6px;
      li{color: #666666;font-size: 14px;line-height: 22px;margin-bottom:6px;}
    }
  }
}
.hot_ranking{
  border-top:none !important;
  .list_title{font-weight:bold;}
}
</style>

